"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const translate_1 = require("components/translate");
const difference_1 = __importDefault(require("lodash/difference"));
const mobx_1 = require("mobx");
const constants_1 = require("modules/classManager/constants");
const ui_1 = require("modules/ui");
const ClassesStore_1 = __importDefault(require("./ClassesStore"));
const request_1 = __importDefault(require("@hotmart/request"));
class ClassesService {
    clear() {
        (0, mobx_1.extendObservable)(ClassesStore_1.default, {
            loaded: false,
            classesList: []
        });
    }
    setData(classesList = {}) {
        this.clear();
        Object.assign(ClassesStore_1.default, { classesList, loaded: true });
    }
    formatClasses(classes = []) {
        classes.map((item) => {
            if (item.name === constants_1.DEFAULT_CLASS.ENTITY) {
                item.name = translate_1.Polyglot.t(constants_1.DEFAULT_CLASS.NAME);
            }
            if (item.defaultClass && !item.suffix) {
                item.suffix = true;
                item.name = translate_1.Polyglot.t('general.class_default', {
                    data: { name: item.name }
                });
            }
            return item;
        });
        return classes;
    }
    getClassesHashIdList() {
        return (0, mobx_1.toJS)(ClassesStore_1.default.classesList).map((classElement) => classElement.hashId);
    }
    async getClassInfo(classId) {
        let classesList = (0, mobx_1.toJS)(ClassesStore_1.default.classesList);
        const index = classesList.findIndex((element) => element.hashId === classId);
        if (index > -1) {
            return classesList[index];
        }
        try {
            const classInfo = await (0, request_1.default)('class.get', { id: classId });
            classesList = classesList.concat(classInfo);
            this.setData(this.formatClasses(classesList));
            return classInfo[0];
        }
        catch (_a) {
            this.handleError();
            return { hashId: classId, name: '-' };
        }
    }
    async getModulesClassesInfos(classesIds) {
        let classesList = (0, mobx_1.toJS)(ClassesStore_1.default.classesList);
        const classesHashList = this.getClassesHashIdList();
        const missingClasses = classesList.length
            ? (0, difference_1.default)(classesIds, classesHashList)
            : classesIds;
        if (missingClasses.length) {
            const classesInfo = await (0, request_1.default)('class.get', {
                id: missingClasses.toString()
            });
            classesList = classesList.concat(classesInfo);
            this.setData(this.formatClasses(classesList));
        }
        return classesList.filter((classElement) => classesIds.includes(classElement.hashId));
    }
    async getAllClassesInfos() {
        const classesInfo = await (0, request_1.default)('class.get');
        const classesList = this.formatClasses(classesInfo);
        this.setData(classesList);
        return classesList;
    }
    async getSelectFormatedClasses() {
        const classesList = await this.getAllClassesInfos();
        const formated = classesList.map((item) => {
            return {
                value: item.hashId,
                label: item.name
            };
        });
        return formated;
    }
    handleError() {
        ui_1.UiService.setAlertError('error');
    }
    fetchClasses(hashIds, productId) {
        return (0, request_1.default)('class.get', { id: hashIds.join(',') }, {
            headers: {
                'x-product-id': productId
            }
        });
    }
}
__decorate([
    mobx_1.action
], ClassesService.prototype, "clear", null);
__decorate([
    mobx_1.action
], ClassesService.prototype, "setData", null);
__decorate([
    mobx_1.action
], ClassesService.prototype, "getClassesHashIdList", null);
__decorate([
    mobx_1.action
], ClassesService.prototype, "getClassInfo", null);
__decorate([
    mobx_1.action
], ClassesService.prototype, "getModulesClassesInfos", null);
__decorate([
    mobx_1.action
], ClassesService.prototype, "getAllClassesInfos", null);
__decorate([
    mobx_1.action
], ClassesService.prototype, "getSelectFormatedClasses", null);
exports.default = new ClassesService();
